import { Component, input } from '@angular/core';
import { PopupComponent } from '../popup/popup.component';

@Component({
  selector: 'app-info-hover',
  imports: [PopupComponent],
  templateUrl: './info-hover.component.html',
  styleUrl: './info-hover.component.css',
})
export class InfoHoverComponent {
  public wide = input<boolean>(false);
}
